import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import lang from '@/lang'

export default createVuetify({
  components,
  directives,
  locale: {
    locale: 'en',
    messages: { zhHant: lang.zhHant, zhHans: lang.zhHans, en: lang.en }
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#1b65f2',
          error: '#cf321d'
        }
      }
    }
  }
})
